var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.75 2.5C11.2102 2.5 11.5833 2.8731 11.5833 3.33333V11.3215L14.3274 8.57741C14.6528 8.25197 15.1805 8.25197 15.5059 8.57741C15.8314 8.90285 15.8314 9.43049 15.5059 9.75592L11.3393 13.9226C11.0138 14.248 10.4862 14.248 10.1607 13.9226L5.99408 9.75592C5.66864 9.43049 5.66864 8.90285 5.99408 8.57741C6.31951 8.25197 6.84715 8.25197 7.17259 8.57741L9.91667 11.3215V3.33333C9.91667 2.8731 10.2898 2.5 10.75 2.5ZM4.08333 13.3333C4.54357 13.3333 4.91667 13.7064 4.91667 14.1667V15.8333C4.91667 16.0543 5.00446 16.2663 5.16074 16.4226C5.31702 16.5789 5.52899 16.6667 5.75 16.6667H15.75C15.971 16.6667 16.183 16.5789 16.3393 16.4226C16.4955 16.2663 16.5833 16.0543 16.5833 15.8333V14.1667C16.5833 13.7064 16.9564 13.3333 17.4167 13.3333C17.8769 13.3333 18.25 13.7064 18.25 14.1667V15.8333C18.25 16.4964 17.9866 17.1323 17.5178 17.6011C17.0489 18.0699 16.413 18.3333 15.75 18.3333H5.75C5.08696 18.3333 4.45107 18.0699 3.98223 17.6011C3.51339 17.1323 3.25 16.4964 3.25 15.8333V14.1667C3.25 13.7064 3.6231 13.3333 4.08333 13.3333Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.b7208cfd51f9f95706bfa8ee3baeb7c1.svg";
export { ForwardRef as ReactComponent };